import { render, staticRenderFns } from "./CommitChangesWindow.vue?vue&type=template&id=21dc9992&"
import script from "./CommitChangesWindow.vue?vue&type=script&lang=ts&"
export * from "./CommitChangesWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports